import * as React from 'react';
import { Card as ChakraCard, type CardRootProps } from '@chakra-ui/react';

/**
 * Project Card.
 *
 * Pass-through over Chakra v3's `Card.Root`. Current NB consumers use
 * `<Card>` as a single styled container, so the wrapper exposes that
 * shape. If later consumers need header / body / footer slots, expose
 * them as `Card.Header` / `Card.Body` / `Card.Footer` here.
 */

export type CardProps = CardRootProps;

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (props, ref) => <ChakraCard.Root ref={ref} {...props} />
);
Card.displayName = 'Card';
